import { createRouter, createWebHistory } from "vue-router";
import { accountLinks } from "@vendata/power-up-links";
import { PageNotFound } from "@saflib/vue/components";

// BEGIN SORTED WORKFLOW AREA page-imports FOR vue/add-view
import AccountSettingsSection from "./pages/account-settings/AccountSettingsSection.vue";
import CompanyProfilePageAsync from "./pages/company-profile/CompanyProfileAsync.vue";
import HomePage from "./pages/home-page/HomePageAsync.vue";
import SupportAsync from "./pages/support/SupportAsync.vue";
// END WORKFLOW AREA

const routes = [
  // BEGIN WORKFLOW AREA page-routes FOR vue/add-view
  { path: accountLinks.home.path, component: HomePage },
  {
    path: accountLinks.profile.path,
    component: AccountSettingsSection,
    props: { section: "profile" },
  },
  {
    path: accountLinks.email.path,
    component: AccountSettingsSection,
    props: { section: "email" },
  },
  {
    path: accountLinks.password.path,
    component: AccountSettingsSection,
    props: { section: "password" },
  },
  {
    path: accountLinks.mfa.path,
    component: AccountSettingsSection,
    props: { section: "totp" },
  },
  {
    path: accountLinks.organization.path,
    component: CompanyProfilePageAsync,
  },
  {
    path: accountLinks.support.path,
    component: SupportAsync,
  },
  // END WORKFLOW AREA
  { path: "/:pathMatch(.*)*", component: PageNotFound },
];

export const router = createRouter({
  history: createWebHistory("/"),
  routes,
});
